<template>
  <footer class="footer">
    <div class="footer-container row-justify">
      <router-link
        v-for="item in routerLinkList"
        :key="item.to"
        :to="item.to"
        tag="div"
        class="footer-item col-center"
        exact
        replace
      >
        <svg class="footer-item-icon">
          <use :xlink:href="item.icon" />
        </svg>
        <span class="footer-item-text">{{ item.text }}</span>
      </router-link>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    routerLinkList() {
      return [
        {
          icon: '#icon-exchange2',
          text: this.$t('exchange.name'),
          to: '/exchange',
        },
        {
          icon: '#icon-post2',
          text: this.$t('post.name'),
          to: '/post',
        },
        {
          icon: '#icon-mine2',
          text: this.$t('mine.name'),
          to: '/mine',
        },
      ];
    },
  },
};
</script>

<style lang="stylus" scoped>
.footer {
  position: fixed;
  bottom: 0;
  z-index: 101;
  width: 100vw;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.footer-container {
  height: 13.07vw;
  box-shadow: 0 -1.07vw 2.13vw 0 rgba(58, 86, 131, 0.07);
  color: color-text-gray;
  padding-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  padding-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
  background: #fff;
}

.footer-item {
  flex: 1 0 33.33vw;

  &.router-link-exact-active {
    color: color-primary;
  }
}

.footer-item-icon {
  icon-size(6.93vw, 6.93vw);
}

.footer-item-text {
  margin-top: 1.07vw;
  font-size: 2.67vw;
  line-height: 1;
}
</style>
